// Utils
import cn from '../../../utils/cn';

// Styles
import styles from './NavigationControl.module.css';

// Components
import NavigationButton from './NavigationButton';

/**
 * @typedef {object} NavigationControlProps
 * @property {() => void} onPrevious - Function called when left button is clicked
 * @property {() => void} onNext - Function called when right button is clicked
 * @property {string} [previousLabel='Previous'] - Aria label for previous button
 * @property {string} [nextLabel='Next'] - Aria label for next button
 * @property {boolean} [disablePrevious=false] - Disable previous button
 * @property {boolean} [disableNext=false] - Disable next button
 * @property {React.ReactNode} [children] - Content to display between buttons
 * @property {string} [className] - Additional CSS classes
 */

/**
 * NavigationControl component with left and right buttons
 * @param {NavigationControlProps} props - The component props
 * @returns {JSX.Element} The NavigationControl component
 */
function NavigationControl({
  onPrevious,
  onNext,
  previousLabel = 'Previous',
  nextLabel = 'Next',
  disablePrevious = false,
  disableNext = false,
  className = '',
}) {
  return (
    <div className={cn([styles.wrapper, className])} data-testid="navigation-control">
      <NavigationButton
        direction="previous"
        onClick={onPrevious}
        label={previousLabel}
        disabled={disablePrevious}
      />
      <NavigationButton
        direction="next"
        onClick={onNext}
        label={nextLabel}
        disabled={disableNext}
      />
    </div>
  );
}

export default NavigationControl;
